import { PQR_RECEIVED_THROUGH_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const usePqrReceivedThroughListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${PQR_RECEIVED_THROUGH_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
